// src/components/Header.tsx
import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { NavLink, Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const navLinks = [
    { name: 'Domov', href: '/' },
    { name: 'O Laserskem Odstranjevanju', href: '/about-laser' },
    { name: 'Cene in Akcije', href: '/pricing' },
    { name: 'Kontakt', href: '/contact' },
    { name: 'Pogosta Vprašanja', href: '/faq' },
  ];

  return (
    <header className="w-full py-4 px-4 sm:px-6 lg:px-8 bg-white/80 backdrop-blur-sm fixed top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto flex justify-between items-center">
        <div className="flex items-center">
          <Link to="/" className="flex items-center" onClick={scrollToTop}>
            <img
              src="/logo.png"
              alt="Derma Klinika Maribor Logo"
              className="w-10 h-10 mr-2"
            />
            <span className="text-2xl font-serif font-semibold text-nail-700">
              Derma<span className="text-gold-500">Klinika</span>
            </span>
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8">
          {navLinks.map((link) => (
            <NavLink
              key={link.name}
              to={link.href}
              className={({ isActive }) =>
                cn(
                  'fancy-underline text-foreground hover:text-nail-600 py-2',
                  isActive && 'text-nail-600 underline'
                )
              }
              onClick={scrollToTop}
            >
              {link.name}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:block">
          <Button asChild className="bg-nail-500 hover:bg-nail-600 text-white">
            <Link to="/contact" onClick={scrollToTop}>
              Naroči se zdaj
            </Link>
          </Button>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-foreground"
          onClick={toggleMenu}
          aria-label="Preklopi meni"
        >
          <div
            className={cn(
              'p-2 border rounded-sm transition-colors',
              isMenuOpen ? 'border-nail-500 hover:border-nail-600' : 'border-foreground/50 hover:border-foreground'
            )}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </div>
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && (
        <div className="md:hidden absolute top-16 left-0 right-0 bg-white shadow-md z-50 animate-fade-in">
          <div className="flex flex-col space-y-4 p-4">
            {navLinks.map((link) => (
              <NavLink
                key={link.name}
                to={link.href}
                className={({ isActive }) =>
                  cn(
                    'text-foreground hover:text-nail-600 py-2',
                    isActive && 'text-nail-600 underline'
                  )
                }
                onClick={() => {
                  toggleMenu();
                  scrollToTop();
                }}
              >
                {link.name}
              </NavLink>
            ))}
            <Button asChild className="bg-nail-500 hover:bg-nail-600 text-white w-full">
              <Link
                to="/contact"
                onClick={() => {
                  toggleMenu();
                  scrollToTop();
                }}
              >
                Naroči se zdaj
              </Link>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;